import PropTypes from 'prop-types';
import React from 'react';
import { TextInput } from 'react-admin';
import { formatCPF, isValidCPF } from '@brazilian-utils/brazilian-utils';

const validateCpf = value => (value && isValidCPF(value) ? undefined : "CPF inválido");

// `onChange` é opcional: os fluxos antigos (Register/Redeem) guardam o CPF em
// useState via callback, o cadastro de cliente lê direto do estado do form.
// `validate` recebido por prop é ADICIONADO ao check de CPF válido, nunca o
// substitui — trocar um pelo outro deixaria passar CPF inválido nas telas antigas.
// Vem antes na lista só por prioridade de mensagem (o RA mostra o primeiro erro):
// campo vazio deve dizer "obrigatório", não "CPF inválido".
export const CpfInput = ({ onChange, validate, ...props }) =>
    <TextInput
        fullWidth
        onChange={(event) => {
            if (onChange) { onChange(event.target.value.replace(/[^\d]/g, '')) }
        }}
        format={(value) => formatCPF(value)}
        parse={(value) => value.replace(/[^\d]/g, '')}
        validate={[...(Array.isArray(validate) ? validate : validate ? [validate] : []), validateCpf]}
        {...props}
    />;

CpfInput.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    source: PropTypes.string.isRequired,
};

CpfInput.defaultProps = {
    source: "cpf",
    label: "CPF"
};
